export const OPEN = 'OPEN'
export const CLOSE = 'CLOSE'

export default {
    OPEN,
    CLOSE,
}
